import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [rawActions.openPdfOptionsDialog](state, action) {
      return true
    },
    [rawActions.closePdfOptionsDialog](state, action) {
      return false
    },
    [rawActions.resetGalleryState](state, action) {
      return false
    },
  },
  false
)
